import { defineStore } from 'pinia';

import { store } from '..';

import { LocaleSetting, LocaleType } from '#/config';

interface LocaleState {
    localInfo: LocaleSetting;
}

export const useLocaleStore = defineStore({
    id: 'app-locale',
    state: (): LocaleState => ({
        localInfo: {
            showPicker: true,
            locale: 'zh_CN',
            fallback: 'zh_CN',
            availableLocales: ['zh_CN', 'en'],
        },
    }),
    getters: {
        getLocale(): LocaleType {
            return this.localInfo.locale ?? 'zh_CN';
        },
        getShowPicker(): boolean {
            return !!this.localInfo?.showPicker;
        },
        hideComponentForCurrentLocale(): boolean {
            return this.getLocale !== 'zh_CN';
        }
    },
    actions: {
        setLocaleInfo(info: Partial<LocaleSetting>) {
            this.localInfo = { ...this.localInfo, ...info };
        },
    }
});

// Need to be used outside the setup
export function useLocaleStoreWithOut() {
    return useLocaleStore(store);
}
